import { useContext, useState } from "react";
import cn from "classnames";
import { Link, useParams } from "react-router-dom";

import { useGetCompareAnswersHook } from "@/modules/assessments/hooks/use-get-compare-answers.hook";
import { useClientByIdHook } from "@/modules/client/hooks/useClientById.hook";

import { Loading } from "@/shared/components/Loading/Loading";
import { ReportComponent, ReportScene } from "@/shared/components/assessment/report/ReportComponent/ReportComponent";
import ReportCompareHeader from "@/shared/components/assessment/report/ReportCompareHeader/ReportCompareHeader";

import { AssessmentContext } from "@/shared/contexts/assessment.context";
import { ReportCompareContext } from "@/shared/contexts/reportCompare.context";
import { getRoute } from "@/shared/utils/route/route.utils";
import { CLIENT_ROUTE, ASSESSMENT_ROUTE, ASSESSMENT_EDIT_INVITES_ROUTE } from "@/routing/AppRouter/routes.constants";
import buttonStyle from "@/ui-components/commonComponents/Button/style.module.css";

import "../../styles/assessmentCommon.css";
import style from "./style.module.css";

export default function AssessmentCompare() {
  const { client_id, assessment_id } = useParams<{ client_id: string; assessment_id: string }>();

  const { assessment } = useContext(AssessmentContext);
  const { client } = useClientByIdHook(Number(client_id));
  const { fetchAnswers, usersAnswers, isLoading: answersLoading } = useGetCompareAnswersHook();

  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [isHiddenSameScore, setIsHiddenSameScore] = useState<boolean>(false);

  if (!client || !assessment) {
    return <Loading />;
  }

  if (assessment?.template) {
    const DEFAULT_ASSESSMENT_PAGE_ROUTE = `/${CLIENT_ROUTE}/${client_id}/${ASSESSMENT_ROUTE}/${assessment_id}`;
    const backRoute = getRoute(DEFAULT_ASSESSMENT_PAGE_ROUTE, ASSESSMENT_EDIT_INVITES_ROUTE);

    return (
      <div className="container">
        <div className="tabs-inner-container-desktop">
          <div className={style.emptyStateContainer}>
            <p className={style.emptyStateMessage}>Compare is not available for assessments created from templates.</p>
            <Link to={backRoute} className={cn(buttonStyle.linkAsButton, buttonStyle.linkAsButtonTransparent)}>
              Go back to Candidates
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ReportCompareContext.Provider value={{ isHiddenSameScore, setIsHiddenSameScore, fetchAnswers, answersLoading }}>
      <ReportComponent
        isPublic
        client={client}
        assessment={assessment}
        selectedUsers={selectedUsers}
        scene={ReportScene.compare}
        usersAnswers={usersAnswers}
        userAnswersLoading={answersLoading}
        compareComponent={
          <ReportCompareHeader
            selectedUsers={selectedUsers}
            showHideSameScore={true}
            setSelectedUsers={setSelectedUsers}
          />
        }
      />
    </ReportCompareContext.Provider>
  );
}
